// extracted by mini-css-extract-plugin
export var menuIcon = "_sc-0";
export var menuIconInline = "_sc-1";